import React from 'react'
import { graphql } from 'gatsby'
import AutoLeasingView from '../../views/autoLeasing'

const AutoLeasingPage = (props) => (
  <AutoLeasingView {...props} productFeatureType="auto-leasing" />
)
export default AutoLeasingPage

export const query = graphql`
  query AutoLeasingQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      sections: pageSection {
        ...servicesFragment
        ...featureFragment
        ... on ContentfulHomepageSlider {
          slideHeading
          slideDescription {
            raw
          }
          sliderCta {
            title
            link
            isExternal
          }
          sliderImage {
            bucketUrl
          }
        }
      }
    }
  }
`
